export const environment = {
  production: false,
  apiUrl: 'https://api-novaurbe-console.democom.tech/api/v1',
};
